var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSorts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fluent:filter-12-filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 2.75C1 2.55109 1.07902 2.36032 1.21967 2.21967C1.36032 2.07902 1.55109 2 1.75 2H10.25C10.4489 2 10.6397 2.07902 10.7803 2.21967C10.921 2.36032 11 2.55109 11 2.75C11 2.94891 10.921 3.13968 10.7803 3.28033C10.6397 3.42098 10.4489 3.5 10.25 3.5H1.75C1.55109 3.5 1.36032 3.42098 1.21967 3.28033C1.07902 3.13968 1 2.94891 1 2.75ZM3 5.75C3 5.55109 3.07902 5.36032 3.21967 5.21967C3.36032 5.07902 3.55109 5 3.75 5H8.25C8.44891 5 8.63968 5.07902 8.78033 5.21967C8.92098 5.36032 9 5.55109 9 5.75C9 5.94891 8.92098 6.13968 8.78033 6.28033C8.63968 6.42098 8.44891 6.5 8.25 6.5H3.75C3.55109 6.5 3.36032 6.42098 3.21967 6.28033C3.07902 6.13968 3 5.94891 3 5.75ZM5.25 8C5.05109 8 4.86032 8.07902 4.71967 8.21967C4.57902 8.36032 4.5 8.55109 4.5 8.75C4.5 8.94891 4.57902 9.13968 4.71967 9.28033C4.86032 9.42098 5.05109 9.5 5.25 9.5H6.75C6.94891 9.5 7.13968 9.42098 7.28033 9.28033C7.42098 9.13968 7.5 8.94891 7.5 8.75C7.5 8.55109 7.42098 8.36032 7.28033 8.21967C7.13968 8.07902 6.94891 8 6.75 8H5.25Z",
    fill: "#242424"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSorts);
export default __webpack_public_path__ + "static/media/sorts.c33e589bee9c0edc8960d4996508652c.svg";
export { ForwardRef as ReactComponent };